import React, { useState, useEffect, useRef } from 'react';
import { Camera, FileText, Eye, Upload, X, Download, User, Phone, Calendar, MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import html2pdf from "html2pdf.js";
import axios from "axios";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.js';
import QRCode from 'qrcode';
import Sanscript from 'sanscript';
import CameraCapture from './CameraCapture';
import { BASE_URL } from './api';
import { convertBase64PdfToImage, getGenderInEnglish, handleSmartReportGenerate } from './medivadiReport/english';
import { handleMarathiSmartReportGenerate } from './medivadiReport/Marathi';
import { handletelaguSmartReportGenerate } from './medivadiReport/Telegu';
import { handlegujrathiSmartReportGenerate } from './medivadiReport/Gujrati';
import { handleSmartReportBangali } from './medivadiReport/bangali';
import { handleSmartReportGenerateOdiya } from './medivadiReport/odiya';

// Shyam and rohan 
const PatientManagement = () => {
        const [patients, setPatients] = useState([]);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);
        const [showAddDetailModal, setShowAddDetailModal] = useState(false);
        const [showViewModal, setShowViewModal] = useState(false);
        const [selectedPatients, setSelectedPatients] = useState([]);
        const [showAddPatientModal, setShowAddPatientModal] = useState(false);
        const [selectedPatient, setSelectedPatient] = useState(null);
        const [patientDocuments, setPatientDocuments] = useState({});
        const [addingPatient, setAddingPatient] = useState(false);
        const [photoFile, setPhotoFile] = useState(null);
        const [idFile, setIdFile] = useState(null);
        const [loanFile, setLoanFile] = useState(null);
        const [isUploading, setIsUploading] = useState(false);
        const [searchTerm, setSearchTerm] = useState('');
        const [campId, setCampId] = useState(null);
        const [packageId, setPackageId] = useState(null);
        const [showCameraModal, setShowCameraModal] = useState(false);
        const [cameraType, setCameraType] = useState('');
        const [selectedLanguage, setSelectedLanguage] = useState('English');
        const [showCampPhotoModal, setShowCampPhotoModal] = useState(false);
        const [technicianPhoto, setTechnicianPhoto] = useState(null);
        const [branchManagerPhoto, setBranchManagerPhoto] = useState(null);
        const [kitPhoto, setKitPhoto] = useState(null);
        const [uploadingCampPhotos, setUploadingCampPhotos] = useState(false);
        const [selectedDate, setSelectedDate] = useState('');
        const dateInputRef = useRef(null);
        const [downloadCount, setDownloadCount] = useState(0);
        const [isDownloadingReports, setIsDownloadingReports] = useState(false);
        const API_BASE_URL = BASE_URL;

        // Form data for adding new patient
        const [newPatient, setNewPatient] = useState({
            patient_id: '',
            name: '',
            age: '',
            gender: 'Male',
            phone: '',
            loan_account_number: '',
            services: [],
            camp_id: 3,
            package_id: 3
        });

        const photoInputRef = useRef(null);
        const aadharInputRef = useRef(null);
        const loanInputRef = useRef(null);
        const navigate = useNavigate();



        useEffect(() => {
            const campId = localStorage.getItem("selectedCampId");
            const packageId = localStorage.getItem("selectedPackageId");

            if (campId && packageId) {
                setCampId(campId);
                setPackageId(packageId);

                // Update newPatient with the IDs
                setNewPatient(prev => ({
                    ...prev,
                    camp_id: parseInt(campId),
                    package_id: parseInt(packageId)
                }));
                console.log("Camp ID and Package ID set:", campId, packageId);
                console.log(newPatient);
            }
        }, []);

        // Save language to localStorage whenever it changes
        useEffect(() => {
            localStorage.setItem("selectedLanguage", selectedLanguage);
            console.log("Selected language changed and saved:", selectedLanguage);
        }, [selectedLanguage]);

        // Load language from localStorage on mount
        useEffect(() => {
            const savedLanguage = localStorage.getItem("selectedLanguage");
            if (savedLanguage) {
                setSelectedLanguage(savedLanguage);
                console.log("Language loaded from localStorage:", savedLanguage);
            }
        }, []);

        // Fetch patients from API
        useEffect(() => {
            if (campId && packageId) {
                fetchPatients();
            }
        }, [campId, packageId]);

        // Fetch report language from Camp Details API
        useEffect(() => {
            const fetchReportLanguage = async () => {
                try {
                    // Wait until both IDs are available
                    if (!campId || !packageId) {
                        console.log("campId or packageId not available yet");
                        return;
                    }
        
                    console.log("Fetching report language for:", {
                        campId,
                        packageId
                    });
        
                    const response = await fetch(
                        `${API_BASE_URL}/api/campmanager/camps/${campId}/details/`
                    );
        
                    if (!response.ok) {
                        throw new Error(`Failed to fetch camp details: ${response.status}`);
                    }
        
                    const data = await response.json();
        
                    console.log("Camp details API response:", data);
        
                    // Find matching package
                    const currentPackage = data?.packages?.find(
                        (pkg) => pkg.id === parseInt(packageId)
                    );
        
                    console.log("Matched package:", currentPackage);
        
                    // Get language or fallback to English
                    const fetchedLanguage =
                        currentPackage?.report_language?.trim() || "English";
        
                    console.log("Fetched report language:", fetchedLanguage);
        
                    // Set selected language
                    setSelectedLanguage(fetchedLanguage);
        
                    // Sync localStorage
                    localStorage.setItem("selectedLanguage", fetchedLanguage);
        
                    console.log(
                        "Selected language updated from API:",
                        fetchedLanguage
                    );
        
                } catch (error) {
                    console.error("Error fetching report language:", error);
        
                    // Fallback to English
                    setSelectedLanguage("English");
                    localStorage.setItem("selectedLanguage", "English");
        
                    console.log("Fallback language set to English");
                }
            };
        
            fetchReportLanguage();
        }, [campId, packageId]);

        const fetchPatients = async() => {
            try {
                setLoading(true);
                const response = await fetch(`${API_BASE_URL}/api/campmanager/patients/filter/?camp_id=${campId}&package_id=${packageId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch patients');
                }
                const data = await response.json();
                setPatients(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        const filteredPatients = patients.filter(p => {
            const searchLower = searchTerm.toLowerCase();
        
            const matchesSearch =
                p.name.toLowerCase().includes(searchLower) ||
                p.unique_patient_id.toLowerCase().includes(searchLower) ||
                p.phone.includes(searchTerm) ||
                (p.email && p.email.toLowerCase().includes(searchLower)) ||
                (p.patient_id && p.patient_id.toLowerCase().includes(searchLower));
        
            const matchesDate =
                !selectedDate || p.test_date === selectedDate;
        
            return matchesSearch && matchesDate;
        });

        const handleAddDetail = (patient) => {
            setSelectedPatient(patient);
            setPhotoFile(null);
            setIdFile(null);
            setLoanFile(null);
            setShowAddDetailModal(true);
        };
        //Add the File Handler Functions
        const handlePhotoChange = (e) => {
            setPhotoFile(e.target.files[0]);
        };

        const handleIdChange = (e) => {
            setIdFile(e.target.files[0]);
        };

        const handleLoanChange = (e) => {
            setLoanFile(e.target.files[0]);
        };

        const handleCloseDetailModal = () => {
            setShowAddDetailModal(false);
            setPhotoFile(null);
            setIdFile(null);
            setLoanFile(null);
        };
        const handleDetailSubmit = async(e) => {
            e.preventDefault();

            if (!photoFile || !idFile) {
                alert('Please select both photo and Aadhar ID files');
                return;
            }

            setIsUploading(true);

            try {
                const formData = new FormData();

                // Log files being uploaded
                console.log('Uploading files:', {
                    photo: photoFile,
                    id: idFile,
                    loan: loanFile
                });

                formData.append('photo', photoFile);
                formData.append('document_file', idFile);
                formData.append('unique_patient_id', selectedPatient.unique_patient_id);

                if (loanFile) {
                    formData.append('loan_document_file', loanFile);
                }

                // Log FormData entries
                for (let pair of formData.entries()) {
                    console.log('FormData entry:', pair[0], pair[1]);
                }

                const response = await fetch(`${API_BASE_URL}/api/campmanager/upload-photo-identity/`, {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || `Upload failed with status ${response.status}`);
                }

                const responseData = await response.json();
                console.log('Upload successful:', responseData);

                alert('Files uploaded successfully!');
                handleCloseDetailModal();
                await fetchPatients();

            } catch (error) {
                console.error('Error uploading files:', error);
                alert(`Error uploading files: ${error.message}`);
            } finally {
                setIsUploading(false);
            }
        };



        const fetchPatientDocuments = async(unique_patient_id) => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/campmanager/patient-documents/${unique_patient_id}/`
                );
                if (!response.ok) throw new Error('Failed to fetch documents');
                const data = await response.json();

                // Transform the API data to match your expected format
                if (data && data.length > 0) {
                    const doc = data[0]; // Get first document
                    return {
                        photo: doc.patient_photo ? {
                            url: doc.patient_photo,
                            name: 'Patient Photo'
                        } : null,
                        aadhar: doc.document_file ? {
                            url: doc.document_file,
                            name: 'Aadhar Document'
                        } : null,
                        loan: doc.loan_document_file ? {
                            url: doc.loan_document_file,
                            name: 'Loan Document'
                        } : null
                    };
                }
                return null;
            } catch (err) {
                console.error("Fetch document error:", err);
                return null;
            }
        };

        const handleView = async(patient) => {
            setSelectedPatient(patient);
            setShowViewModal(true);

            const documents = await fetchPatientDocuments(patient.unique_patient_id);
            if (documents) {
                setPatientDocuments((prev) => ({
                    ...prev,
                    [patient.id]: documents
                }));
            }
        };






        const handleCloseViewModal = () => {
            setShowViewModal(false);
        };


        const handleServices = (patient) => {
            // Make sure we're passing the patient object correctly
            navigate(`/medibuddy-form/${patient.unique_patient_id}`, {
                state: {
                    unique_patient_id: patient.unique_patient_id,
                    name: patient.name
                }
            });
        };




        const generateQRCodeBase64 = async(patient) => {
            const patientInfo = `Patient ID: ${patient.unique_patient_id}
    Name: ${patient.name}
    Age: ${patient.age}
    Loan Number: ${patient.loan_number}
    Adahar Number: ${patient.aadhar_number}
    Phone: ${patient.phone}
    Gender: ${patient.gender}`;

            try {
                console.log("Generating QR Code for:", patientInfo);

                // Check if QRCode library exists
                if (typeof QRCode === 'undefined') {
                    throw new Error("QRCode library not loaded");
                }

                const qrCode = await QRCode.toDataURL(patientInfo, {
                    width: 120,
                    margin: 2,
                    color: {
                        dark: '#000000',
                        light: '#FFFFFF'
                    }
                });

                console.log("QR Code generated successfully");
                return qrCode;
            } catch (err) {
                console.error("QR generation error:", err);
                // Return a placeholder or throw the error instead of empty string
                throw err;
            }
        };


  const handleTechnicianPhoto = (e) => {
      setTechnicianPhoto(e.target.files[0]);
  };

  const handleBranchManagerPhoto = (e) => {
      setBranchManagerPhoto(e.target.files[0]);
  };

  const handleKitPhoto = (e) => {
      setKitPhoto(e.target.files[0]);
  };

  const getCurrentLocation = () => {
      return new Promise((resolve, reject) => {

          navigator.geolocation.getCurrentPosition(

              (position) => {

                  resolve({
                      latitude: position.coords.latitude,
                      longitude: position.coords.longitude
                  });

              },

              (error) => reject(error)

          );

      });
  };

  const uploadSinglePhoto = async (file, photoType) => {

      if (!file) return;

      const location = await getCurrentLocation();

      const token = localStorage.getItem("token");

      if (!token) {
          alert("Please login again.");
          return;
      }

      const formData = new FormData();

      formData.append("camp", campId);
      formData.append("photo_type", photoType);
      formData.append("image", file);
      formData.append("latitude", location.latitude);
      formData.append("longitude", location.longitude);

      await axios.post(
          "https://cbackend.xraidigital.com/api/upload-photo/",
          formData,
          {
              headers: {
                  Authorization: `Token ${token}`,
                  "Content-Type": "multipart/form-data",
              },
          }
      );

  };

  const handleCampPhotoUpload = async () => {

      try {

          setUploadingCampPhotos(true);

          await uploadSinglePhoto(
              technicianPhoto,
              "SELFIE"
          );

          await uploadSinglePhoto(
              branchManagerPhoto,
              "BRANCH_MANAGER"
          );

          await uploadSinglePhoto(
              kitPhoto,
              "KIT"
          );

          alert("Camp photos uploaded successfully.");

          setShowCampPhotoModal(false);

          setTechnicianPhoto(null);
          setBranchManagerPhoto(null);
          setKitPhoto(null);

      }

      catch (error) {

          console.log(error);

          alert("Photo upload failed.");

      }

      finally {

          setUploadingCampPhotos(false);

      }

  };




  const handleBulkSmartReportDownload = async () => {
    if (selectedPatients.length === 0) {
      alert("Please select at least one patient");
      return;
    }
   
    setIsDownloadingReports(true);
    setDownloadCount(0); 

    let successCount = 0;
    const errors = [];

    for (const patientId of selectedPatients) {
      const patient = patients.find(
        p => p.unique_patient_id === patientId
      );

      if (!patient) continue;

      try {
        const response = await handleReport(patient);

        if (response.status === 200) {
          // ✅ Report exists → download
          await downloadPdfFromResponse(response, patient);
          successCount++;
          setDownloadCount(successCount);

        } else if (response.status === 404) {
          // ⚠ Report missing → generate + upload (frontend)
          await getSmartReportHandler()(patient, BASE_URL, API_BASE_URL);

          // 🔁 Retry download after generation
          const retryResponse = await handleReport(patient);

          if (retryResponse.status === 200) {
            await downloadPdfFromResponse(retryResponse, patient);
            successCount++;
            setDownloadCount(successCount);
          } else {
            throw new Error("Download failed after generation");
          }

        } else {
          throw new Error(`Server error (${response.status})`);
        }

      } catch (err) {
        errors.push(
          `${patient.name || "Patient"} (${patient.unique_patient_id}): ${err.message}`
        );
      }
    }

    setIsDownloadingReports(false);

    if (errors.length > 0) {
      alert(
        "Some smart reports could not be processed:\n\n" +
        errors.join("\n")
      );
    }
  };


  const handleReport = async (patient) => {
    const response = await fetch(
      `${API_BASE_URL}/api/technician/smart-report/download/?patient_ids=${patient.unique_patient_id}`,
      { method: 'GET' }
    );

    return response;
  };

  const downloadPdfFromResponse = async (response, patient) => {
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    const safeName = patient.name
    ? patient.name.replace(/[^a-zA-Z0-9]/g, "_")
    : "Patient";
    a.href = url;
    a.download = `Smart_Report_${safeName}_${patient.unique_patient_id}.pdf`;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleAddPatient = () => {
    setNewPatient({
      patient_id: '',
      name: '',
      age: '',
      gender: 'Male',
      phone: '',
      loan_account_number: '',
      aadhar_number: '', 
      services: [],
      camp_id: 3,
      package_id: 3
    });
    setShowAddPatientModal(true);
  };

  const handleServiceToggle = (service) => {
    setNewPatient(prev => ({
      ...prev,
      services: prev.services.includes(service)
        ? prev.services.filter(s => s !== service)
        : [...prev.services, service]
    }));
  };

  const submitNewPatient = async () => {
  try {
    setAddingPatient(true);

    // Validate required fields
    if (!newPatient.patient_id || !newPatient.name || !newPatient.age || !newPatient.phone) {
      alert('Please fill all required fields');
      return;
    }

    // Create patient
    const response = await fetch(`${API_BASE_URL}/api/campmanager/patients/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...newPatient,
        age: parseInt(newPatient.age),
        camp_id: parseInt(campId),
        package_id: parseInt(packageId),
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create patient');
    }

    const createdPatient = await response.json();

    // Print thermal slip (must use id because backend uses PatientData.objects.get(id=pid))
    try {
      const patientIdForPrint = createdPatient.id;

      if (!patientIdForPrint) {
        console.error('No id returned for patient:', createdPatient);
      } else {
        await fetch(`${API_BASE_URL}/api/campmanager/print-thermal-slips/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            patient_ids: [patientIdForPrint], // ✅ must be DB id
          }),
        });
      }
    } catch (printError) {
      console.error('Failed to print thermal slip:', printError);
    }

    // Close modal first
    setShowAddPatientModal(false);

    // Then fetch updated patient list
    await fetchPatients();

    alert('Patient added successfully and thermal slip printed!');
  } catch (err) {
    alert('Error adding patient: ' + err.message);
  } finally {
    setAddingPatient(false);
  }
};

  const handleFileUpload = (type, file) => {
    if (!selectedPatient) return;
    
    const patientId = selectedPatient.id;
    setPatientDocuments(prev => ({
      ...prev,
      [patientId]: {
        ...prev[patientId],
        [type]: {
          file,
          url: URL.createObjectURL(file),
          name: file.name
        }
      }
    }));
  };


  const handleWhatsApp = async (patient) => {
  try {
    const response = await fetch('https://cbackend.xraidigital.com/api/technician/send-whatsapp/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        patient_id: parseInt(patient.id), // Use patient.id, not unique_patient_id
        remarks: `Smart Report PDF for ${patient.name} (ID: ${patient.unique_patient_id})`
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to send WhatsApp message');
    }

    const result = await response.json();
    alert('WhatsApp message sent successfully!');
    console.log('WhatsApp response:', result);
    
  } catch (error) {
    console.error('WhatsApp error:', error);
    alert(`Error sending WhatsApp message: ${error.message}`);
  }
};

  const handleBulkWhatsApp = async () => {
    if (selectedPatients.length === 0) {
      alert("Please select at least one patient");
      return;
    }

    try {
      for (const patientId of selectedPatients) {
        const patient = patients.find(
          p => p.unique_patient_id === patientId
        );

        if (!patient) continue;

        const response = await fetch(
          'https://cbackend.xraidigital.com/api/technician/send-whatsapp/',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              patient_id: parseInt(patient.id), // backend expects DB id
              remarks: `Smart Report PDF for ${patient.name} (ID: ${patient.unique_patient_id})`
            })
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          console.error(`Failed for ${patient.name}`, errorData);
        }
      }

      alert("WhatsApp messages sent to selected patients!");

    } catch (error) {
      console.error("Bulk WhatsApp error:", error);
      alert("Error sending bulk WhatsApp messages");
    }
  };

  const handleSMS = async (patient) => {
    try {
      const response = await fetch(
        `https://cbackend.xraidigital.com/api/technician/send-sms/${patient.id}/`,
        {
          method: 'GET', // ✅ IMPORTANT
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to send SMS');
      }

      alert('SMS sent successfully!');
      console.log('SMS response:', result);

    } catch (error) {
      console.error('SMS error:', error);
      alert(`Error sending SMS: ${error.message}`);
    }
  };

  const handleBulkSMS = async () => {
    if (selectedPatients.length === 0) {
      alert("Please select at least one patient");
      return;
    }

    try {
      for (const patientId of selectedPatients) {
        const patient = patients.find(
          p => p.unique_patient_id === patientId
        );

        if (!patient) continue;

        const response = await fetch(
          `https://cbackend.xraidigital.com/api/campmanager/send-sms/${patient.id}/`,
          {
            method: 'GET'
          }
        );

        const result = await response.json();

        if (!response.ok) {
          console.error(`Failed for ${patient.name}`, result);
        }
      }

      alert("SMS sent to selected patients!");

    } catch (error) {
      console.error("Bulk SMS error:", error);
      alert("Error sending bulk SMS");
    }
  };



const allPatientIds = filteredPatients.map(p => p.unique_patient_id);
const isAllSelected =
  filteredPatients.length > 0 &&
  filteredPatients.every(p =>
    selectedPatients.includes(p.unique_patient_id)
  );


const handleDownloadAllReports = async () => {
  try {
    // Show loading state
    const button = document.querySelector('button'); // You might want to add a loading state
    
    // Get all unique patient IDs from filtered or all patients
    const patientsToDownload = filteredPatients.length ? filteredPatients : patients;
    const patientIds = patientsToDownload.map(patient => patient.unique_patient_id).join(',');
    
    if (patientIds.length === 0) {
      alert('No patients found to download reports for.');
      return;
    }

    // Call the API with all patient IDs
    const response = await fetch(`${API_BASE_URL}/api/technician/smart-report/download/?patient_ids=${patientIds}`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to download reports');
    }

    // Get the blob from the response
    const blob = await response.blob();
    
    // Create a download link and trigger download
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `All_Patient_Reports_${new Date().toISOString().split('T')[0]}.pdf`; // Set filename with date
    document.body.appendChild(a);
    a.click();
    
    // Cleanup
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    console.log(`Downloaded reports for ${patientsToDownload.length} patients`);

  } catch (error) {
    console.error('Error downloading all reports:', error);
    alert('Failed to download reports. Please try again.');
  }
};

  const handleCameraCapture = (type) => {
  setCameraType(type);
  setShowCameraModal(true);
};

const handleCameraCapture_Complete = (capturedFile) => {
  if (cameraType === 'photo') setPhotoFile(capturedFile);
  if (cameraType === 'aadhar') setIdFile(capturedFile);
  if (cameraType === 'loan') setLoanFile(capturedFile);
  setShowCameraModal(false);
};

const handleCameraClose = () => {
  setShowCameraModal(false);
  setCameraType('');
};
  const FileUploadSection = ({ type, label, inputRef }) => {
    const handleFileChange = (file) => {
      if (type === 'photo') setPhotoFile(file);
      if (type === 'aadhar') setIdFile(file);
      if (type === 'loan') setLoanFile(file);
    };
  
    const getCurrentFile = () => {
      if (type === 'photo') return photoFile;
      if (type === 'aadhar') return idFile;
      if (type === 'loan') return loanFile;
      return null;
    };
  
    const currentFile = getCurrentFile();
  
    return (
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label} *
        </label>
        <div className="flex gap-2">
          <button
            onClick={() => inputRef.current?.click()}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Upload className="w-4 h-4" />
            Choose File
          </button>
          <button
            onClick={() => handleCameraCapture(type)}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            <Camera className="w-4 h-4" />
            Camera
          </button>
        </div>
        
        <input
          ref={inputRef}
          type="file"
          className="hidden"
          accept="image/*,.pdf"
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) handleFileChange(file);
          }}
        />
        
        {currentFile && (
          <div className="mt-2 text-sm text-green-600">
            ✓ {currentFile.name} selected
          </div>
        )}
      </div>
    );
  };


const getSmartReportHandler = () => {
  console.log("Current language:", selectedLanguage);
  switch (selectedLanguage) {
    case 'Marathi':  return handleMarathiSmartReportGenerate;
    case 'Telegu':    return handletelaguSmartReportGenerate;  // Fixed: was incorrectly labeled as Telugu
    case 'Gujarati': return handlegujrathiSmartReportGenerate;
    case 'Bengali':  return handleSmartReportBangali;
    case 'Odiya':    return handleSmartReportGenerateOdiya;
    default:         return handleSmartReportGenerate;
  }
};
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-lg text-gray-600">Loading patients...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-lg text-red-600">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8 gap-4">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Patient Management</h1>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto">   
              <select
                value={selectedLanguage}
                onChange={(e) => setSelectedLanguage(e.target.value)}
                className="bg-white border border-gray-300 text-gray-700 px-4 py-2 md:py-3 rounded-lg font-medium text-sm md:text-base focus:ring-2 focus:ring-blue-500"
              >
                <option value="English">🌐 English</option>
                <option value="Bengali">বাংলা</option>
                <option value="Gujarati">ગુજરાતી</option>
                <option value="Telegu">తTelegu</option>
                <option value="Marathi">मराठी</option>
                <option value="Odiya">ଓଡ଼ିଆ</option>
              </select>
              <button
                onClick={handleAddPatient}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 md:px-6 py-2 md:py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2 text-sm md:text-base"
              >
                <User className="w-4 h-4 md:w-5 md:h-5" />
                Add Patient
              </button>
              <button
                  onClick={() => setShowCampPhotoModal(true)}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-3 rounded-lg font-medium"
              >
                  Camp Photos
              </button>
              <button
                onClick={handleBulkSmartReportDownload}
                disabled={isDownloadingReports}
                className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded disabled:opacity-50"
              >
                <Download size={16} />
                {isDownloadingReports
                  ? `Downloading... (${downloadCount}/${selectedPatients.length})`
                  : `Download Smart Reports${downloadCount > 0 ? ` (${downloadCount} done)` : ''}`}
              </button>
              <button
                onClick={handleBulkWhatsApp}
                className="px-4 py-2 bg-green-600 text-white rounded"
              >
                Send Bulk WhatsApp
              </button>
              <button
                onClick={handleBulkSMS}
                className="px-4 py-2 bg-green-600 text-white rounded"
              >
                Send Bulk SMS
              </button>
            </div>
          </div>
         
          {/* Date + Search Filter */}
          <div className="mb-6 flex flex-col md:flex-row gap-4">
          
            {/* Date Filter (Auto Open) */}
            <div
              onClick={() => dateInputRef.current?.showPicker()}
              className="px-4 py-3 border border-gray-300 rounded-lg cursor-pointer bg-white focus-within:ring-2 focus-within:ring-blue-500"
            >
              <input
                ref={dateInputRef}
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="w-full outline-none cursor-pointer bg-transparent"
              />
            </div>
          
            {/* Search */}
            <input
              type="text"
              placeholder="Search by name, ID or phone..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          
            {/* Clear */}
            <button
              onClick={() => setSelectedDate('')}
              className="px-4 py-2 bg-gray-500 text-white rounded-lg"
            >
              Clear Date
            </button>
          
          </div>
        
        {/* Desktop Table View */}
        <div className="hidden lg:block bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedPatients(allPatientIds);
                          } else {
                            setSelectedPatients([]);
                          }
                        }}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                      />

                      <span className="text-xs text-gray-600 normal-case">
                        ({selectedPatients.length})
                      </span>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Patient
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredPatients.map((patient) => (
                  <tr key={patient.id} className="hover:bg-gray-50">
                    <td className="px-4 py-4">
                      <input
                        type="checkbox"
                        checked={selectedPatients.includes(patient.unique_patient_id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedPatients(prev => [...prev, patient.unique_patient_id]);
                          } else {
                            setSelectedPatients(prev =>
                              prev.filter(id => id !== patient.unique_patient_id)
                            );
                          }
                        }}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                      />
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-12 w-12">
                          <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center">
                            <User className="w-6 h-6 text-blue-600" />
                          </div>
                        </div>
                        <div className="ml-4">
                          <div className="text-base font-medium text-gray-900">{patient.name}</div>
                          <div className="text-sm text-gray-500">ID: {patient.unique_patient_id}</div>
                          <div className="text-sm text-gray-500">Age: {patient.age} | Gender: {patient.gender}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="grid grid-cols-3 gap-2">
                        <button onClick={() => handleAddDetail(patient)} className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded text-xs font-medium transition-colors">Add Detail</button>
                        <button onClick={() => handleServices(patient)} className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded text-xs font-medium transition-colors">Medical Form</button>
                        <button onClick={() => getSmartReportHandler()(patient, BASE_URL, API_BASE_URL)} className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-2 rounded text-xs font-medium transition-colors">Smart Report</button>
                        <button onClick={() => handleReport(patient)} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded text-xs font-medium transition-colors">Download Report</button>
                        <button onClick={() => handleWhatsApp(patient)} className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded text-xs font-medium transition-colors">Send WhatsApp</button>
                        <button onClick={() => handleView(patient)} className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded text-xs font-medium transition-colors">View Detail</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        
        {/* Mobile Card View */}
        <div className="lg:hidden space-y-4">
          {filteredPatients.map((patient) => (
            <div key={patient.id} className="bg-white rounded-lg shadow-md p-4">
              <div className="flex items-start gap-3 mb-4">
                <input
                  type="checkbox"
                  checked={selectedPatients.includes(patient.unique_patient_id)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedPatients(prev => [...prev, patient.unique_patient_id]);
                    } else {
                      setSelectedPatients(prev =>
                        prev.filter(id => id !== patient.unique_patient_id)
                      );
                    }
                  }}
                  className="mt-2 w-4 h-4 text-blue-600 border-gray-300 rounded"
                />
                <div className="flex-shrink-0 h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center">
                  <User className="w-6 h-6 text-blue-600" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-medium text-gray-900 truncate">{patient.name}</h3>
                  <p className="text-sm text-gray-500">ID: {patient.unique_patient_id}</p>
                  <p className="text-sm text-gray-500">Age: {patient.age} | {patient.gender}</p>
                </div>
              </div>
              
              <div className="grid grid-cols-2 gap-2 mb-3">
                <button onClick={() => handleAddDetail(patient)} className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-1">
                  <Upload className="w-4 h-4" />
                  Add Detail
                </button>
                <button onClick={() => handleServices(patient)} className="bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-1">
                  <Calendar className="w-4 h-4" />
                  Services Form
                </button>
              </div>
              
              <div className="grid grid-cols-2 gap-2">
                <button onClick={() => getSmartReportHandler()(patient, BASE_URL, API_BASE_URL)} className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-1">
                  <FileText className="w-4 h-4" />
                  Smart Report
                </button>
                <button onClick={() => handleReport(patient)} className="bg-orange-600 hover:bg-orange-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-1">
                  <Download className="w-4 h-4" />
                  Dowlnload Report 
                </button>
                <button onClick={() => handleWhatsApp(patient)} className="bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-1">
                  <MessageCircle className="w-4 h-4" />
                  Send WhatsApp
                </button>
                <button onClick={() => handleView(patient)} className="bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center justify-center gap-1">
                  <Eye className="w-4 h-4" />
                  View Detail
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
        
      {/* Add Detail Modal */}
      {showAddDetailModal && selectedPatient && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold text-gray-900">Upload Patient Details</h2>
                <button
                  onClick={handleCloseDetailModal}  // ✅ CORRECT
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                <div className="text-sm text-gray-600">Patient ID: {selectedPatient.unique_patient_id}</div>
                <div className="text-lg font-semibold text-gray-900">Name: {selectedPatient.name}</div>
              </div>

              <FileUploadSection
                type="photo"
                label="Patient Photo"
                inputRef={photoInputRef}
              />
              
              <FileUploadSection
                type="aadhar"
                label="Aadhar ID Document"
                inputRef={aadharInputRef}
              />
              
              <FileUploadSection
                type="loan"
                label="Loan ID Document"
                inputRef={loanInputRef}
              />

            <div className="flex gap-3 mt-8">
              <button
                onClick={handleCloseDetailModal}
                className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-lg font-medium transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleDetailSubmit}
                disabled={isUploading}
                className="flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
              >
                {isUploading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Uploading...
                  </>
                ) : (
                  'Upload Files'
                )}
              </button>
            </div>
            </div>
          </div>
        </div>
      )}

      {showCampPhotoModal && (

        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">

        <div className="bg-white rounded-lg w-full max-w-lg p-6">

        <h2 className="text-xl font-bold mb-6">
        Daily Camp Photos
        </h2>

        <div className="space-y-5">

        <div>

        <label className="block mb-2 font-medium">

        Technician Selfie

        </label>

        <input
        type="file"
        accept="image/*"
        onChange={handleTechnicianPhoto}
        />

        </div>

        <div>

        <label className="block mb-2 font-medium">

        Branch Manager Photo

        </label>

        <input
        type="file"
        accept="image/*"
        onChange={handleBranchManagerPhoto}
        />

        </div>

        <div>

        <label className="block mb-2 font-medium">

        Kit Photo

        </label>

        <input
        type="file"
        accept="image/*"
        onChange={handleKitPhoto}
        />

        </div>

        </div>

        <div className="flex justify-end gap-3 mt-8">

        <button
        onClick={() => setShowCampPhotoModal(false)}
        className="px-5 py-2 bg-gray-300 rounded"
        >

        Cancel

        </button>

        <button
        onClick={handleCampPhotoUpload}
        disabled={uploadingCampPhotos}
        className="px-5 py-2 bg-green-600 text-white rounded"
        >

        {uploadingCampPhotos ? "Uploading..." : "Upload"}

        </button>

        </div>

        </div>

        </div>

        )}

      {/* View Modal */}
      {showViewModal && selectedPatient && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold text-gray-900">Patient Details</h2>
                <button
                  onClick={handleCloseViewModal}  // ✅ CORRECT
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Patient Info */}
              <div className="bg-gray-50 rounded-lg p-4 mb-6">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <div className="flex items-center gap-2 text-gray-600 mb-1">
                      <User className="w-4 h-4" />
                      <span className="text-sm">Name</span>
                    </div>
                    <div className="font-semibold">{selectedPatient.name}</div>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 text-gray-600 mb-1">
                      <FileText className="w-4 h-4" />
                      <span className="text-sm">Patient ID</span>
                    </div>
                    <div className="font-semibold">{selectedPatient.unique_patient_id}</div>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 text-gray-600 mb-1">
                      <Calendar className="w-4 h-4" />
                      <span className="text-sm">Age</span>
                    </div>
                    <div className="font-semibold">{selectedPatient.age} years</div>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 text-gray-600 mb-1">
                      <Phone className="w-4 h-4" />
                      <span className="text-sm">Phone</span>
                    </div>
                    <div className="font-semibold">{selectedPatient.phone}</div>
                  </div>
                </div>
              </div>

             {/* Documents */}
<div className="space-y-4 mb-6">
  <h3 className="text-lg font-semibold text-gray-900">Documents</h3>
  
  {['photo', 'aadhar', 'loan'].map((docType) => {
    const doc = patientDocuments[selectedPatient.id]?.[docType];
    const labels = {
      photo: 'Patient Photo',
      aadhar: 'Aadhar ID Document',
      loan: 'Loan ID Document'
    };
    
    return (
      <div key={docType} className="border rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="font-medium text-gray-900">{labels[docType]}</div>
          {doc ? (
            <div className="flex items-center gap-2">
              <span className="text-sm text-green-600">✓ Uploaded</span>
              <a
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
              >
                <Eye className="w-4 h-4" />
                View
              </a>
              <a
                href={doc.url}
                download={doc.name}
                className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
              >
                <Download className="w-4 h-4" />
                Download
              </a>
            </div>
          ) : (
            <span className="text-sm text-gray-500">Not uploaded</span>
          )}
        </div>
        
        {/* Show image preview for photo */}
        {doc && docType === 'photo' && (
          <div className="mt-3">
            <img 
              src={doc.url} 
              alt="Patient Photo" 
              className="w-24 h-24 rounded-lg object-cover border"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}
      </div>
    );
  })}
</div>


              {/* Services */}
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3">Services</h3>
                <div className="flex flex-wrap gap-2">
                  {selectedPatient.services.map((service, index) => (
                    <span
                      key={index}
                      className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"
                    >
                      {service}
                    </span>
                  ))}
                </div>
              </div>

              {/* Report Download */}
              <div className="border-t pt-4">
                <button
                  onClick={() => handleReport(selectedPatient)}
                  className="w-full bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center justify-center gap-2"
                >
                  <Download className="w-4 h-4" />
                  Download Report
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Patient Modal */}
      {showAddPatientModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-xl font-bold text-gray-900">Add New Patient</h2>
                <button
                  onClick={() => setShowAddPatientModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Patient ID *
                  </label>
                  <input
                    type="text"
                    value={newPatient.patient_id}
                    onChange={(e) => setNewPatient(prev => ({ ...prev, patient_id: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter patient ID "
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Name *
                  </label>
                  <input
                    type="text"
                    value={newPatient.name}
                    onChange={(e) => setNewPatient(prev => ({ ...prev, name: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter patient name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Age *
                  </label>
                  <input
                    type="number"
                    value={newPatient.age}
                    onChange={(e) => setNewPatient(prev => ({ ...prev, age: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter age"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Gender *
                  </label>
                  <select
                    value={newPatient.gender}
                    onChange={(e) => setNewPatient(prev => ({ ...prev, gender: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Phone *
                  </label>
                  <input
                    type="tel"
                    value={newPatient.phone}
                    onChange={(e) => setNewPatient(prev => ({ ...prev, phone: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter phone number"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Loan Number
                  </label>
                  <input
                    type="text"
                    value={newPatient.loan_account_number}
                    onChange={(e) => setNewPatient(prev => ({ ...prev, loan_account_number: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter loan number"
                  />
                </div>  
              </div>
               <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Aadhar Number
                  </label>
                  <input
                    type="text"
                    value={newPatient.aadhar_number}
                    onChange={(e) => setNewPatient(prev => ({ ...prev,aadhar_number: e.target.value }))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter Aadhar number"
                  />
                </div>  

              <div className="mt-6">
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Services *
                </label>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {[ 'Pathology', 'Vitals'].map((service) => (
                    <label key={service} className="flex items-center space-x-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={newPatient.services.includes(service)}
                        onChange={() => handleServiceToggle(service)}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700">{service}</span>
                    </label>
                  ))}
                </div>
              </div>
   
              <div className="flex gap-3 mt-8">
                <button
                  onClick={() => setShowAddPatientModal(false)}
                  disabled={addingPatient}
                  className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-700 px-4 py-2 rounded-lg font-medium transition-colors disabled:opacity-50"
                >
                  Cancel
                </button>
                <button
                  onClick={submitNewPatient}
                  disabled={addingPatient}
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {addingPatient ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                      Adding...
                    </>
                  ) : (
                    'Add Patient'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <CameraCapture
        isOpen={showCameraModal}
        onClose={handleCameraClose}
        onCapture={handleCameraCapture_Complete}
        captureType={cameraType}
      />
    </div>
  );
};
//code 

export default PatientManagement;